var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "kanban-group-selector" },
    [
      _c(
        "a-popover",
        {
          attrs: {
            trigger: "click",
            placement: "bottomLeft",
            "overlay-class-name": "group-selector-popover",
          },
          scopedSlots: _vm._u([
            {
              key: "content",
              fn: function () {
                return [
                  _c("div", { staticClass: "selector-content" }, [
                    _c(
                      "div",
                      { staticClass: "selector-header" },
                      [
                        _c("div", { staticClass: "selector-title" }, [
                          _vm._v("Gruplama Alanı Seç"),
                        ]),
                        _vm._v(" "),
                        _c(
                          "a-input",
                          {
                            staticClass: "search-input",
                            attrs: { placeholder: "Ara...", size: "small" },
                            model: {
                              value: _vm.searchQuery,
                              callback: function ($$v) {
                                _vm.searchQuery = $$v
                              },
                              expression: "searchQuery",
                            },
                          },
                          [
                            _c(
                              "i",
                              {
                                staticClass: "material-icons",
                                attrs: { slot: "prefix" },
                                slot: "prefix",
                              },
                              [_vm._v("search")]
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "selector-body" },
                      _vm._l(_vm.filteredCategories, function (category) {
                        return _c(
                          "div",
                          {
                            key: category.key,
                            staticClass: "category-section",
                          },
                          [
                            _c("div", { staticClass: "category-title" }, [
                              _c(
                                "i",
                                { staticClass: "material-icons category-icon" },
                                [_vm._v(_vm._s(category.icon))]
                              ),
                              _vm._v(
                                "\n                            " +
                                  _vm._s(category.label) +
                                  "\n                        "
                              ),
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "category-items" },
                              _vm._l(category.fields, function (field) {
                                return _c(
                                  "div",
                                  {
                                    key: field.key,
                                    staticClass: "field-item",
                                    class: {
                                      "is-active":
                                        _vm.selectedField === field.key,
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.handleFieldSelect(field)
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "i",
                                      {
                                        staticClass:
                                          "material-icons field-icon",
                                      },
                                      [_vm._v(_vm._s(field.icon))]
                                    ),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "field-label" }, [
                                      _vm._v(_vm._s(field.label)),
                                    ]),
                                    _vm._v(" "),
                                    _vm.selectedField === field.key
                                      ? _c(
                                          "i",
                                          {
                                            staticClass:
                                              "material-icons check-icon",
                                          },
                                          [_vm._v("check")]
                                        )
                                      : _vm._e(),
                                  ]
                                )
                              }),
                              0
                            ),
                          ]
                        )
                      }),
                      0
                    ),
                  ]),
                ]
              },
              proxy: true,
            },
          ]),
          model: {
            value: _vm.visible,
            callback: function ($$v) {
              _vm.visible = $$v
            },
            expression: "visible",
          },
        },
        [
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "selector-trigger",
              class: { "is-open": _vm.visible },
            },
            [
              _c("i", { staticClass: "material-icons trigger-icon" }, [
                _vm._v(_vm._s(_vm.currentFieldIcon)),
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "trigger-label" }, [
                _vm._v(_vm._s(_vm.currentFieldLabel)),
              ]),
              _vm._v(" "),
              _c("i", { staticClass: "material-icons arrow-icon" }, [
                _vm._v(_vm._s(_vm.visible ? "expand_less" : "expand_more")),
              ]),
            ]
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }